import { render, staticRenderFns } from "./algo-dashboard.html?vue&type=template&id=5b330cbb&scoped=true&external"
import script from "./algo-dashboard.js?vue&type=script&lang=js&external"
export * from "./algo-dashboard.js?vue&type=script&lang=js&external"
import style0 from "./algo-dashboard.scss?vue&type=style&index=0&id=5b330cbb&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b330cbb",
  null
  
)

export default component.exports